// extracted by mini-css-extract-plugin
module.exports = {"select":"Chain_select__34Fre","bg-red":"Chain_bg-red__2BO9s","red":"Chain_red__2eYzT"};